import { Button, colors } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import React, { MutableRefObject } from 'react'

import { useModal } from '@/context/ModalContext'
import { ListingCate } from '@/page-commons/listingBySlug'
import { handleListingDetailClick } from '@/utils/tracking/eventsHandlers'

import Calendar from '../Icon/Calendar'
import FlashOn from '../Icon/FlashOn'
import Phone from '../Icon/Phone'

import { RequestContactModal, requestContactModalOptions } from './RequestContactModal'

export type RequestType = 'visit' | 'info'

type Props = {
  className?: string
  isMobile?: boolean
  listing: ListingCate
  listingTitle: string
  requestType?: RequestType
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

export const RequestContactCTA: React.FC<Props> = ({
  className,
  isMobile = false,
  listing,
  listingTitle,
  requestType = 'visit',
  similarPropertiesRef,
  ...props
}: Props) => {
  const { openModal } = useModal()
  const { t } = useTranslation()

  const isVisitButton = requestType === 'visit'

  const eventLabel = {
    call: 'RequestCall',
    visit: 'RequestVisit',
  }[requestType]

  const openRequestContactModal = () => {
    handleListingDetailClick(eventLabel)

    openModal(
      <RequestContactModal
        listing={listing}
        listingTitle={listingTitle}
        requestType={requestType}
        similarPropertiesRef={similarPropertiesRef}
      />,
      requestContactModalOptions
    )
  }
  if (isVisitButton) {
    return (
      <Button
        fullWidth
        className={className}
        Icon={(props) =>
          isVisitButton ? (
            <Calendar {...props} />
          ) : (
            <FlashOn {...props} color={colors.orange600} height="14" viewBox="0 0 7 14" width="7" />
          )
        }
        label={isMobile ? t('listing-detail:request_visit_CTA_mobile') : t('listing-detail:request_visit')}
        sizeVariant={isMobile ? 'small' : 'medium'}
        onClick={openRequestContactModal}
        {...props}
      />
    )
  }

  return (
    <Button
      fullWidth
      className={className}
      data-testid="request-call-button"
      Icon={(props) => <Phone {...props} height={20} width={20} />}
      label={t('listing-detail:request_call')}
      sizeVariant={isMobile ? 'small' : 'medium'}
      styleVariant="tertiary"
      onClick={openRequestContactModal}
    />
  )
}
